module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.a0cb10b5.jpg";